import React from 'react';
import './styles/app.scss';
import AppRouter from './routes/AppRouter';

function App() {
    return (
        <AppRouter />
    );
}
export default App;
